<template>
  <div class="page-home">
    <div class="m-hd">
      <top />
    </div>
    <div class="m-bd">
      <router-view />
    </div>
    <div class="m-ft">
      <Bottom />
    </div>
  </div>
</template>
<script>
import Top from './components/Top'
import Bottom from './components/Bottom'

export default {
  components: {
    Top,
    Bottom
  }
}
</script>
<style lang="scss" scoped>
  .m-bd{
    width: 1200px;
    background-color: #fff;
    margin:0 auto;
  }
</style>
